import { MeetingFieldsFragment, MeetingRelationAccessLinkFragment } from '@/@generated/codegen/API';

const getNonDeletableMeetingIds = (
  meetingList: (MeetingFieldsFragment & MeetingRelationAccessLinkFragment)[]
): string[] => {
  const nonDeletableMeetings: string[] = [];

  meetingList.forEach((meeting) => {
    if (meeting.accessLinks && meeting.accessLinks.edges.length > 0)
      nonDeletableMeetings.push(meeting.id);
  });
  return nonDeletableMeetings;
};

export default getNonDeletableMeetingIds;
